(function(){
  function init(root){
    (root||document).querySelectorAll('[data-ww-home-tabs]').forEach(function(tabs){
      if(tabs.dataset.ready==='true') return;
      tabs.dataset.ready='true';
      var buttons=[].slice.call(tabs.querySelectorAll('[data-home-tab]'));
      var panels=[].slice.call(tabs.querySelectorAll('[data-home-panel]'));
      function activate(button){
        var key=button.getAttribute('data-home-tab');
        buttons.forEach(function(b){var active=b===button;b.setAttribute('aria-selected',String(active));b.tabIndex=active?0:-1;});
        panels.forEach(function(panel){panel.hidden=panel.getAttribute('data-home-panel')!==key;});
      }
      buttons.forEach(function(button,index){
        button.addEventListener('click',function(){activate(button)});
        button.addEventListener('keydown',function(event){
          if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          var next=index;
          if(event.key==='ArrowRight') next=(index+1)%buttons.length;
          if(event.key==='ArrowLeft') next=(index-1+buttons.length)%buttons.length;
          if(event.key==='Home') next=0;
          if(event.key==='End') next=buttons.length-1;
          buttons[next].focus();activate(buttons[next]);
        });
      });
      if(buttons[0]) activate(buttons.find(function(b){return b.getAttribute('aria-selected')==='true'})||buttons[0]);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){init(document)}); else init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
})();
